<div class="hx-chat-message__layout">
  <div class="hx-chat-message__avatar" aria-hidden="true">
    @if (avatarSrc()) {
      <img class="hx-chat-message__avatar-img" [src]="avatarSrc()" [alt]="senderName()" loading="lazy" />
    } @else {
      <div class="hx-chat-message__avatar-initials">{{ displayInitials() }}</div>
    }
  </div>

  <div class="hx-chat-message__body">
    <div class="hx-chat-message__bubble" [attr.aria-label]="message()">
      <div class="hx-chat-message__header">
        @if (senderName()) {
          <span class="hx-chat-message__sender">{{ senderName() }}</span>
        }
        @if (timestampDate()) {
          <time class="hx-chat-message__time" [attr.datetime]="timestampDate() | date: 'yyyy-MM-ddTHH:mm'">
            {{ timestampDate() | date: 'shortTime' }}
          </time>
        }
      </div>
      <p class="hx-chat-message__text">{{ message() }}</p>
    </div>
  </div>
</div>
